import { Component, Fragment } from 'react';
import { View, TouchableOpacity, Image } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Notifications, AccessTimeFilled, Book, Settings, HeadsetMic, Logout  } from '@mui/icons-material';

import { Creators as toastActions } from '../../store/ducks/toast';
import { Creators as userActions } from '../../store/ducks/user';
import { Creators as menuActions } from '../../store/ducks/menu-ativo';
import { Creators as pedidosActions } from '../../store/ducks/pedidos';
import { Creators as pedidoSelecionadoActions } from '../../store/ducks/pedido-selecionado';
import { Creators as produtoSelecionadoActions } from '../../store/ducks/produto-selecionado';
import { Creators as departamentoSelecionadoActions } from '../../store/ducks/departamento-selecionado';

import styles from './styles';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';
import { deleteAllCookies } from '../../config/Cookies';
import { Modal } from '../../components-reactjs/Modal';
import { ModalSair } from './components/modalSair';

import ModalAjuda from '../../components/modalAjuda';

import ModalDisponibilidadeLoja from '../../screens/disponibilidade/index.js';


import {
    getInfoCompany,
    saveDispCompany
} from '../../screens/disponibilidade/api';

import { deleteNotificacaoChave } from './../../services/Api';
import { Tooltip } from '@mui/material';
import AsyncStorage from '@react-native-async-storage/async-storage';

const logo = require('../../assets/img/launcher.png');
const logoOff = require('../../assets/img/gestao-off.png');
 
const iconMap = {
    'alert': Notifications,
    'history-filled': AccessTimeFilled,
    'book-filled': Book,
    'settings-solid': Settings,
    'logoff-filled': Logout,
    'support': HeadsetMic
};

        class TabBar extends Component {
    state = {
        dsLoja: '',
        tabActive: 'alert',
        isDisponivel: false,
        modalLogoutIsOpen: false,
        modalDisponibilidadeLojaIsOpen: false,
        modalAjudaIsOpen: false
    };

    async componentWillMount() {
        await this.setCompanyInfo();
    }


    renderTabButton = (onPress, icon) => {
        const { menuAtivo } = this.props,
            color = icon === menuAtivo ? Colors.primary : Colors.grey,
            tabItemStyle = [
                styles.tabItem,
                icon === menuAtivo ? styles.lessPadding : null
            ],
            buttonStyle = [icon === menuAtivo ? styles.itemButtonAtivo : null];

        const IconComponent = iconMap[icon];

        return (
            <TouchableOpacity
                style={tabItemStyle}
                onPress={() => onPress(icon)}
            >
                <View style={buttonStyle}>
                    <IconComponent 
                        style={{ 
                            fontSize: 30, 
                            color: color 
                        }} 
                    />
                </View>
            </TouchableOpacity>
        );
    };

    renderLogoutButton = () => {
        return (
            <View style={styles.tabItem}>
                <button
                    style={{
                        backgroundColor: Colors.transparent,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                        width: '100%',
                        marginBottom: 2,
                        border: 'none',
                        paddingVertical: Layout.isDesktop
                            ? Layout.gutterBig
                            : Layout.gutter
                    }}
                    onClick={this.onPressLock}
                >
                    <Logout 
                        style={{ 
                            fontSize: 24, 
                            color: Colors.grey 
                        }} 
                    />
                </button>
            </View>
        );
    };

    callTooltip = (obj, message) => {
        if (Layout.isDesktop) {
            return (
                <Tooltip title={<div style={{ fontSize: '1.6rem', fontFamily: 'NunitoSans-Regular' }}>{message}</div>}  
                 placement='right'
                >
                    <div>{obj}</div>
                </Tooltip>
            );
        } else {
            return <div>{obj}</div>;
        }
    };

    setTabActive = (tabActive, tabScreen) => {
        this.props.deselectPedido();
        this.props.deselectDepartamento();
        this.props.selectMenu(tabActive);
        this.props.navigation.navigate(tabScreen);
        this.setState({ tabActive });
    };

    onPressAlert = (tabActive) => {
        this.setTabActive(tabActive, 'Home');
    };

    onPressHistory = (tabActive) => {
        this.setTabActive(tabActive, 'HistoricoPedido');
    };

    onPressBook = (tabActive) => {
        this.setTabActive(tabActive, 'Departamento');
    };

    onPressConfiguracoes = (tabActive) => {
        this.setTabActive(tabActive, 'Configuracoes');
    };

    onPressLock = () => {
        this.setState({ modalLogoutIsOpen: true });
    };

    modalClosed = () => {
        this.setState({ modalLogoutIsOpen: false });
    };

    onLogOut = () => {
        return new Promise(async (resolve, reject) => {
            if (await AsyncStorage.getItem('token')) {
                await AsyncStorage.clear();
                this.props.userRemove();
                this.props.deselectPedido();
                this.props.clearProdutoSelecionado();
                this.props.clearPedidos();
                deleteAllCookies();
                resolve(true);
            } else {
                resolve(true);
            }
        });
    };

    openModalDisponibilidade = () => {
        this.setState({
            modalDisponibilidadeLojaIsOpen: true
        });
    };

    closeModalDisponibilidade = () => {
        this.setState({
            modalDisponibilidadeLojaIsOpen: false
        });
    };

    openModalAjuda = () => {
        this.setState({
            modalAjudaIsOpen: true
        });
    };

    closeModalAjuda = () => {
        this.setState({
            modalAjudaIsOpen: false
        });
    };

    onChangeDisponibilidade = () => {
        const isDisponivel = !this.state.isDisponivel ? 1 : 0,
            { addToast } = this.props;

        saveDispCompany({ isDisponivel })
            .then((response) => {
                const { data } = response,
                    { message } = data;

                addToast({
                    text: message,
                    theme: 'success',
                    autoHideTime: 3000
                });
            })
            .catch((error) => {
                const { message } = error[0] || {};

                addToast({
                    text: message,
                    theme: 'error',
                    autoHideTime: 3000
                });
            });

        this.setState({
            isDisponivel
        });
    };

    setCompanyInfo = async () => {
        const infoCompany = await getInfoCompany(),
            { loja } = infoCompany,
            { dsLoja, fgDisponivelApp } = loja || {};

        this.setState({
            isDisponivel: fgDisponivelApp,
            dsLoja
        });
    };

    handleCloseModalLogout = () => {
        this.setState({ modalLogoutIsOpen: false });
    };

    render() {
        const { user } = this.props,
            { configLoja = {} } = user,
            { fgKds = false } = configLoja,
            {
                dsLoja = '',
                isDisponivel = false,
                modalLogoutIsOpen = false,
                modalDisponibilidadeLojaIsOpen = false,
                modalAjudaIsOpen = false
            } = this.state;

        return (
            <Fragment>
                <View style={styles.tabBar}>
                    <View style={styles.tabBarContent}>
                        {this.callTooltip(
                            <View style={styles.itemLogo}>
                                <button
                                    style={{
                                        backgroundColor: Colors.transparent,
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: 2,
                                        border: 'none'
                                    }}
                                    onClick={this.openModalDisponibilidade}
                                >
                                    <Image
                                        resizeMode="contain"
                                        style={styles.logo}
                                        source={isDisponivel ? logo : logoOff}
                                    />
                                </button>
                            </View>,
                            'Disponibilidade'
                        )}

                        {this.callTooltip(
                            this.renderTabButton(this.onPressAlert, 'alert'),
                            'Pedidos'
                        )}
                        {this.callTooltip(
                            this.renderTabButton(
                                this.onPressHistory,
                                'history-filled'
                            ),
                            'Histórico'
                        )}
                        {this.callTooltip(
                            !fgKds &&
                                this.renderTabButton(
                                    this.onPressBook,
                                    'book-filled'
                                ),
                            'Produtos'
                        )}
                        {this.callTooltip(
                            <TouchableOpacity
                                style={styles.tabItem}
                                onPress={this.openModalAjuda}
                            >
                                <View>
                                    <HeadsetMic
                                        style={{ 
                                            fontSize: 30, 
                                            color: Colors.grey 
                                        }} 
                                    />
                                </View>
                            </TouchableOpacity>,
                            'Suporte'
                        )}
                        {this.callTooltip(
                            this.renderTabButton(
                                this.onPressConfiguracoes,
                                'settings-solid'
                            ),
                            'Configurações'
                        )}
                        {this.callTooltip(this.renderLogoutButton(), 'Sair')}
                    </View>
                </View>

                {modalDisponibilidadeLojaIsOpen && (
                    <ModalDisponibilidadeLoja
                        nomeLoja={dsLoja}
                        isDisponivel={isDisponivel}
                        isOpen={modalDisponibilidadeLojaIsOpen}
                        onClose={this.closeModalDisponibilidade}
                        onChange={this.onChangeDisponibilidade}
                        isMobile={!Layout.isDesktop}
                    />
                )}

                {modalAjudaIsOpen && (
                    <ModalAjuda
                        isOpen={modalAjudaIsOpen}
                        onClose={this.closeModalAjuda}
                    />
                )}

                {modalLogoutIsOpen && (
                    <Modal
                        setIsOpen={this.handleCloseModalLogout}
                        isOpen={modalLogoutIsOpen}
                    >
                        <ModalSair
                            handleCloseModalLogout={this.handleCloseModalLogout}
                            onLogoutHandler={this.onLogOut}
                        />
                    </Modal>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = ({ user, menuAtivo }) => ({
    menuAtivo,
    user
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...toastActions,
            ...userActions,
            ...pedidosActions,
            ...menuActions,
            ...pedidoSelecionadoActions,
            ...produtoSelecionadoActions,
            ...departamentoSelecionadoActions
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TabBar);
